<template>
    <div class="hasLogin">
        <div class="head" @click="isLang = !isLang" ref="head" :class="{ zh: $i18n.locale == 'zh' }"><svg version="1.1" id="图层_1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 26.8 26.8" style="enable-background:new 0 0 26.8 26.8;fill-rule:evenodd;clip-rule:evenodd;"
                xml:space="preserve" ref="svg">

                <path ref="path" class="st0" d="M26.8,13.4C26.8,6.1,21,0.2,13.8,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0C6,0,0,6,0,13.4
	c0,7.4,6,13.4,13.4,13.4c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0C21,26.6,26.8,20.7,26.8,13.4z M13.5,23.9
	C13.5,23.9,13.5,23.9,13.5,23.9c-1,0-1.9-2.4-2.4-5.9h4.5C15.2,21.4,14.5,23.8,13.5,23.9z M10.9,15c0-0.5,0-1,0-1.5c0-0.5,0-1,0-1.5
	h5c0,0.5,0,1,0,1.5c0,0.5,0,1,0,1.5H10.9z M13.5,3C13.5,3,13.5,3,13.5,3c1,0.1,1.8,2.5,2.1,5.9h-4.5C11.6,5.4,12.6,3,13.5,3z
	 M18.9,11.9h4.8c0.1,0.5,0.1,1,0.1,1.5c0,0.5-0.1,1-0.1,1.5h-4.8c0-0.5,0-1,0-1.5C18.9,12.9,18.9,12.4,18.9,11.9z M22.8,8.9h-4.1
	c-0.2-1.9-0.6-3.7-1.2-5.1C19.8,4.8,21.7,6.6,22.8,8.9z M9.5,3.7C8.8,5.2,8.4,6.9,8.1,8.9H4C5.1,6.6,7.1,4.7,9.5,3.7z M3.1,11.9h4.7
	c0,0.5,0,1,0,1.5c0,0.5,0,1,0,1.5H3.1C3,14.5,3,13.9,3,13.4C3,12.9,3,12.4,3.1,11.9z M4,18h4.1c0.3,2,0.8,3.7,1.4,5.1
	C7.1,22.1,5.1,20.3,4,18z M17.5,23c0.5-1.4,0.9-3.1,1.2-5.1h4.1C21.7,20.2,19.8,22,17.5,23z" />
            </svg>
        </div>
        <div class="lang" @click="isLang = !isLang" ref="lang">{{ this.$i18n.locale == 'en' ? 'Global' : '中国' }}</div>
        <transition name="fade">
            <div class="outbox" v-if="isLang" ref="box">
                <div class="innerbox">
                    <div class="li" v-for="li, index in ul" :key="index" @click="setLang(li.data)">{{ li.lang }}</div>
                </div>
            </div>
        </transition>
    </div>
</template>
 
<script>
import i18n from "../lang";
//此页为通用页头
export default {
    props: ['ul'],
    inject: ['reload'],
    data() {
        return {
            num: 0,
            dis: "none",
            changeLang: false,
            isLang: false
        };
    },
    mounted() {
        document.addEventListener('click', event => {
            var a = this.$refs.box
            var b = this.$refs.head
            var c = this.$refs.lang
            var d = this.$refs.path
            var e = this.$refs.svg

            if (event.target != a && event.target != b && event.target != c && event.target != d && event.target != e) {
                this.isLang = false
            }
        })
    },
    watch: {
        'changeLang'(oldval, newval) {
            if (this.changeLang == true) {

            }
        },
        // 'i18n.locale'(){

        // }
    },
    methods: {
        setLang(lang) {
            this.showList()
            if (this.preferredLang !== lang) {
                const currentURL = window.location.href;

                if (currentURL.includes('.com')) {
                    // 在包含 .com 的情况下执行的操作
                    console.log('URL contains .com');
                    window.location.href = 'https://support.partyanimals.cn/'
                    // 进行其他操作
                } else if (currentURL.includes('.cn')) {
                    // 在包含 .cn 的情况下执行的操作
                    console.log('URL contains .cn');
                    window.location.href = 'https://support.partyanimals.com/'
                    // 进行其他操作
                } else {
                    // window.location.href = 'https://www.bilibili.com/'
                    this.preferredLang = lang;
                    localStorage.setItem("preferredLang", lang);
                    document.documentElement.lang = lang;
                    i18n.locale = lang;
                    this.$router.go(0)
                    this.$store.commit("Logout");
                }
                if (Object.prototype.hasOwnProperty.call(window, "scrollTo")) {
                    scrollTo(0, 0);
                } else {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }

            }
        },
        Logout() {
            this.showList()
            this.$store.commit("Logout");
        },
        showList() {
            this.isLang = false
        },
    }
};
</script>
<style lang="scss" scoped>
.hasLogin {
    // position: absolute;
    font-family: 'Nunito-Bold';
    // width: 225px;
    height: 65px;
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;

    .lang {
        display: none;
        font-family: "Nunito-Bold", HYZhengYuan-65W, Microsoft YaHei, sans-serif;
        color: #5b5b5b;
    }

    .outbox {
        position: absolute;
        top: 60px;
        font-family: 'Nunito-Bold', HYZhengYuan-65W, Microsoft YaHei, sans-serif;
        font-size: 16px;
        color: #5c5956;
        line-height: 42px;
        background-color: rgba(255, 255, 255);
        border: 1px solid #e1e0dd;
        box-shadow: 0px 10px 24px 0px rgb(0 0 0 / 8%);
        border-radius: 18px;
        padding: 0px;
        transition: all ease .2s;

        // padding: ;
        .innerbox {
            font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei, sans-serif;
            margin: 10px;

            text-align: left;
            border-radius: 14px;
            transition: all .2s ease;

            .li {
                transition: all .4s;
                text-align: center;
                padding: 3px 15px 0;
                border-radius: 12px;
                cursor: pointer;
                min-width: 70px;
                white-space: nowrap;

                &:hover {
                    background-color: #fceaad;
                }

                &:active {
                    background-color: #ffcc00;
                    color: #ffffff;
                }
            }
        }

        z-index: 200;
    }

    .head {
        width: 24px;
        z-index: 100;
        height: 24px;
        cursor: pointer;
        margin-right: -7px;
        &.zh{
            margin-right: -8px;
        }
        svg {
            fill: #5F5F5F;
            transition: all .4s;

            &:hover {

                fill: #f87e35;

            }
        }


    }

}

@media screen and (max-width:1100px) {

    .hasLogin {
        .lang {
            display: block;
            font-family: "MohrRounded Black", "FZLanTYK_Black", Microsoft YaHei, sans-serif;
            padding-top: 4px;
            cursor: pointer;
        }

        &.phone {
            display: flex;
            flex-direction: row;

            .head {
                margin-right: 8px;

                svg {
                    fill: #5F5F5F;
                    transition: all .4s;

                    &:hover {

                        fill: #5F5F5F;

                    }
                }
            }
        }
    }

    .hasLogin .outbox {
        position: absolute;
        top: -110px;
    }

    .hasLogin .outbox .innerbox .li {
        text-align: center !important;
    }
}
</style>